import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { MatDialogModule } from '@angular/material/dialog';
import { ModalDialogComponent } from './modal-dialog.component';
import { SvgIconModule } from 'shared/components/svg-icon/svg-icon.module';
import { ModalService } from 'shared/components/modal-dialog/modal-dialog.service';
import { MatCheckboxModule } from '@angular/material/checkbox';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule.forChild(),
    SvgIconModule,
    MatDialogModule,
    MatCheckboxModule
  ],
  declarations: [
    ModalDialogComponent
  ],
  providers: [
    ModalService
  ]
})
export class ModalDialogModule {}
